import axios from "axios";
import { Navigate } from "react-router-dom";

const login = (email, password, rememberMe) => {
  return axios
    .post(process.env.REACT_APP_API_URL + "admin/login", {
      email,
      password,
    })
    .then((response) => {
      if (response.data) {
        const u = response.data?.userInfo;
        const token =
          u?.token ?? u?.dataValues?.token ?? "";
        const userObj =
        {
          id: u?.id ?? u?.dataValues?.id,
          publicId: u?.publicId ?? u?.dataValues?.publicId,
          role: u?.roleId ?? u?.dataValues?.roleId,
          fullName: u?.fullName ?? u?.dataValues?.fullName,
          email: u?.email ?? u?.dataValues?.email,
          expiry: u?.expiry ?? u?.dataValues?.expiry,
          token,
          profileImage: u?.profileImage ?? u?.dataValues?.profileImage,
          storeId: u?.storeId ?? u?.dataValues?.storeId
        }

        localStorage.setItem("_bna", JSON.stringify(userObj));
      }
      return response.data.userInfo;
    });
};

const refreshToken = (userId, refreshToken) => {
  return axios
    .post(process.env.REACT_APP_API_URL + "user/renewSession", {
      userId,
      refreshToken,
    })
    .then((response) => {
      if (response?.data?.response?.newSessionToken) {
        const userObj = {
          token: response?.data?.response?.newSessionToken,
          refreshToken: null,
        };
        localStorage.setItem("_bna", JSON.stringify(userObj));
      }
      return response.data.userInfo;
    });
};

const logout = () => {
  localStorage.removeItem("_bna");
  <Navigate to="/login" />;
};

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { login, logout, refreshToken };
